module.exports = __webpack_public_path__ + "static/img/021_2.71d046f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/021_2.jpg
// module id = S9fp
// module chunks = 1